var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 5.718,
    viewBox: "0 0 10 5.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow_open",
    d: "M11.189,12.97l3.781,3.784a.712.712,0,0,0,1.009,0,.721.721,0,0,0,0-1.012L11.7,11.455a.713.713,0,0,0-.985-.021L6.4,15.739a.715.715,0,0,0,1.009,1.012Z",
    transform: "translate(-6.188 -11.246)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOpen);
export default __webpack_public_path__ + "static/media/arrow_open.38b819e57b27bebac08e9ed8c2a30426.svg";
export { ForwardRef as ReactComponent };